enum Routes {
  FRIENDS = '/friends',
}

export default Routes
